<script setup>
import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { store } from '@/store/store';

import axios from 'axios';
import TextEventScheduleDay from '@/components/TextEventScheduleDay.vue'

const dayjs = require('dayjs')
const _ = require("lodash");

const route = useRoute()
const router = useRouter()
const eventId = route.params.eventId
let status = ref('loading')
let data = ref({
    Event: {},
    Schedule: [],
    Days: []
})
let showPastShifts = ref(false)
let hasFutureShifts = ref(false)

async function getSchedule() {
    let url = "/api/schedule/" + eventId
    try {
        let res = await axios.get(url)
        store.currentEventName = res.data.Event.Name
        store.currentEventStart = res.data.Event.StartDate
        store.currentEventEnd = res.data.Event.EndDate
        data.value.Event = res.data.Event

        if (res.data.Schedule.length > 0) {
            data.value.Schedule = _.orderBy(res.data.Schedule, ['Start'], ['asc'])
            let currDate = null
            data.value.Schedule.forEach(shift => {
                let shiftStartDate = dayjs(shift.Start)
                let shiftEndDate = dayjs(shift.End)

                if (shiftStartDate > dayjs()) {
                    hasFutureShifts.value = true
                }

                if (currDate == null) {
                    currDate = {
                        Date: dayjs(data.value.Schedule[0].Start).format("MM/DD/YYYY"),
                        Shifts: []
                    }
                    pushShift(currDate, shift)
                }
                else {
                    // if the shift is on a different date, add in the previous currDate instance and make a new one
                    if (shiftStartDate.format("MM/DD/YYYY") != currDate.Date) {
                        data.value.Days.push(currDate)
                        currDate = {
                            Date: dayjs(shift.Start).format("MM/DD/YYYY"),
                            Shifts: []
                        }
                        pushShift(currDate, shift)
                    }
                    // if the shift ends on a different date, add two records
                    else if (shiftEndDate.format("MM/DD/YYYY") != shiftStartDate.format("MM/DD/YYYY")) {
                        pushShift(currDate, shift)
                    }
                    else {
                        pushShift(currDate, shift)
                    }
                }
            });
            data.value.Days.push(currDate)
        }

        status.value = 'loaded'
        showPastShifts.value = !hasFutureShifts.value
    }
    catch (ex) {
        if (ex.response && ex.response.status == 401)
            router.push('/')
        else
            console.log(ex)
    }
}

function pushShift(currDate, shift) {
    currDate.Shifts.push({
        Position: shift.Position,
        Department: shift.Department,
        Start: shift.Start,
        End: shift.End,
        Weight: shift.Weight,
        Status: shift.Status,
        HoursWorked: shift.HoursWorked,
        Note: shift.Note,
        PlusDays: false,
    })
}
getSchedule()

const hasAnyShifts = computed(() => {
    return data.value.Days.length > 0
})

const scheduleDays = computed(() => {
    return showPastShifts.value === false ? data.value.Days.filter(x => x.Shifts.filter(y => dayjs(y.Start) > dayjs()).length > 0) : data.value.Days
})

const workedCredits = computed(() => {
    return data.value.Days.reduce((a, b) => a + (b.Shifts.filter(x => x.Status == "ok").reduce((acc, curr) => acc + curr.HoursWorked * curr.Weight, 0)), 0)
})

const showPastShiftFilter = computed(() => {
    return status.value == "loaded" && hasAnyShifts.value && hasFutureShifts.value
})

const eventIsOver = computed(() => {
    return dayjs(data.value.Event.EndDate) < dayjs()
})
</script>

<template>
    <v-row>
        <v-col>
            <span class="text-h4">{{ store.currentEventName }}</span><br>
            Earned Credit Hours: {{ workedCredits }}<br>
            <div v-show="showPastShiftFilter">
                <input type="checkbox" v-model="showPastShifts" id="onlyFuture" class="show-past" /> <label class="small show-past"
                    for="onlyFuture">
                    Show Past Shifts</label>
            </div>
        </v-col>
    </v-row>
    <v-row v-for="item in scheduleDays" :key="item">
        <TextEventScheduleDay :item="item" />
    </v-row>
    <v-alert type="error" v-show="!hasAnyShifts && status == 'loaded'">
        {{  eventIsOver ? "You did not sign up for any shifts during this event." : "You have not signed up for any shifts for this event." }}
     </v-alert>
    <v-alert type="info" v-show="hasAnyShifts && scheduleDays.length == 0 && status == 'loaded'">There are no shifts to show.</v-alert>
    <v-alert type="info" v-show="status == 'loading'">Fetching data.</v-alert>
</template>

<style scoped>
.show-past {
    cursor: pointer;
}

</style>